/**
 * 환자 질환 구분 코드 반환
 * @param {number|string} dissAt - 질환 유무 (0: 정상, 1: 질환 있음)
 * @param {number|string} dabtsDgnssAt - 당뇨 진단 여부 (1: 진단)
 * @param {number|string} hhprsDgnssAt - 고혈압 진단 여부 (1: 진단)
 * @returns {'NML' | 'DM' | 'HBP' | 'DM_HBP'}
 */
export const getPatntHealthStatus = (dissAt, dabtsDgnssAt, hhprsDgnssAt) => {
    // dissAt가 0(또는 '0')이면 정상(NML) 반환
    if (String(dissAt) === '0') {
        return 'NML';
    }

    const isDm = String(dabtsDgnssAt) === '1';
    const isHbp = String(hhprsDgnssAt) === '1';

    // dissAt가 1인 경우 상세 질환 판별
    if (isDm && isHbp) return 'DM_HBP';
    if (isDm) return 'DM';
    if (isHbp) return 'HBP';

    return 'NML';
};